import i18n from 'i18next';

export const shipmentPdfThirdPartyUtils = ({
  customerKey,
  customerBillToName,
  customerBillToAdd,
  shipmentTerms,
  brokerageCustomer,
  customerBillToCountry,
  customerBillToCity,
  customerBillToState,
  customerBillToPostal,
}) => {
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (customerKey == 5791) {
    if (!!customerBillToName && !!customerBillToAdd) {
      return {
        name: 'TricorBraun c/o nVision Global',
        address1: '1900 Brannan Road, Suite 300',
        address2: 'US/McDonough/GA/30253',
      };
    }
    if (
      // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      shipmentTerms == 3 &&
      // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      String(brokerageCustomer).toLowerCase() == 'y' &&
      !!customerBillToName &&
      !!customerBillToAdd
    ) {
      return {
        name: 'nVision Global SCS',
        address1: '1900 Brannon Road',
        address2: 'US/McDonough/GA/30253',
      };
    }
    return {
      name: String(customerBillToName),
      address1: String(customerBillToAdd),
      address2: `${customerBillToCountry}/${customerBillToCity}/${customerBillToState}/${customerBillToPostal}`,
    };
  }
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (shipmentTerms == 3) {
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
    if (String(brokerageCustomer).toLowerCase() == 'y' && !customerBillToName && !customerBillToAdd) {
      return {
        name: 'nVision Global SCS',
        address1: '1900 Brannon Road',
        address2: 'US/McDonough/GA/30253',
      };
    }
    if (!!customerBillToName && !!customerBillToAdd) {
      return {
        name: String(customerBillToName),
        address1: String(customerBillToAdd),
        address2: `${customerBillToCity}/${customerBillToState}/${customerBillToPostal}`,
        address2Label: `${i18n.t('translation:default.fields.city.label')}/${i18n.t('translation:default.fields.state.label')}/Zip`,
      };
    }
    return {
      name: String(customerBillToName),
      address1: String(customerBillToAdd),
      address2: `${customerBillToCountry}/${customerBillToCity}/${customerBillToState}/${customerBillToPostal}`,
    };
  }
  return {
    name: String(customerBillToName),
    address1: String(customerBillToAdd),
    address2:
      customerBillToCountry && customerBillToCity && customerBillToCity
        ? `${customerBillToCountry}/${customerBillToCity}/${customerBillToState}/${customerBillToPostal}`
        : '',
  };
};

export const getFreightChargeTerms = (customerKey, shipmentTerms) => {
  let terms = '';
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (customerKey == 5791) {
    terms = `${i18n.t('translation:default.fields.shipmentTerms.option_p')} ______ Collect ______ 3rd Party ___X___ `;
  } else {
    if (shipmentTerms != null) {
      // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      if (shipmentTerms == 'P') {
        terms = `${i18n.t('translation:default.fields.shipmentTerms.option_p')} ___X___ Collect ______ 3rd Party ______ `;
        // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      } else if (shipmentTerms == 'C') {
        terms = `${i18n.t('translation:default.fields.shipmentTerms.option_p')} ______ Collect ___X___ 3rd Party ______ `;
        // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      } else if (shipmentTerms == '3') {
        terms = `${i18n.t('translation:default.fields.shipmentTerms.option_p')} ______ Collect ______ 3rd Party ___X___ `;
      } else {
        terms = `${i18n.t('translation:default.fields.shipmentTerms.option_p')} ______ Collect ______ 3rd Party ______ `;
      }
    } else {
      terms = `${i18n.t('translation:default.fields.shipmentTerms.option_p')} ______ Collect ______ 3rd Party ______ `;
    }
  }
  return terms;
};
